import React, { Component } from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, Button, Input, DropdownButton, MenuItem, InputPurchaseQuote } from 'react-bootstrap';
import Selection from '../Common/selection';
import Spinner from '../Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';

class PurchaseScheduleModal extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    componentDidMount() {
        this.props.fetchPurchaseTemplates();
    }

    handleFormSubmit(formProps) {
        if (formProps.PurchaseTemplate_id) this.setPurchaseTemplate(formProps.PurchaseTemplate_id.value);
        else (this.context.router.push('purchaseSchedule/new'))
    }

    setPurchaseTemplate(id) {
        const { resetCurrentPurchaseTemplate, resetCurrentPurchaseSchedule, purchaseTemplates, selectPurchaseTemplate } = this.props
        resetCurrentPurchaseTemplate();
        resetCurrentPurchaseSchedule();
        if(id) {
            const index = _.findIndex(purchaseTemplates, { 'PurchaseTemplate_id': id });
            selectPurchaseTemplate(purchaseTemplates[index] );
            // this.context.router.push('/purchaseQuote/'+purchaseTemplates[index].PurchaseTemplate_id);
        }
        this.context.router.push('/purchaseSchedule/new');

    }

    renderPurchaseTemplates() {
        if (this.props.isLoading) return <Col sm={ 12 } className="marginTopStyle"><Spinner/></Col> // If group is loading, show a spinner.
        else {
            let purchaseTemplateOptions = this.getPurchaseTemplateOptions();
            return (
                <Col sm={ 12 } className="marginTopStyle">
                    <label className="centerStyle" ><Translate value="msg_select_a_purchase_template" /></label>
                    <Field name="PurchaseTemplate_id" component={Selection} options={purchaseTemplateOptions}/>
                </Col>
            )
        }
    }

    getPurchaseTemplateOptions() {
        var purchaseTemplateOptions = [];
        this.props.purchaseTemplates.map(purchaseTemplate => {
            purchaseTemplateOptions.push({ value: purchaseTemplate.PurchaseTemplate_id, label: purchaseTemplate.Name })
        });
        return purchaseTemplateOptions;
    }

    // Once User choose a Template, show him some detail
    renderTemplateDetail(id) {
        const { purchaseTemplates } = this.props;
        const index = _.findIndex(purchaseTemplates, { 'PurchaseTemplate_id': id });
        const vendorName = purchaseTemplates[index].Vendor_id__Name;
        const updateTime = purchaseTemplates[index].UpdateTime;
        const PONum = purchaseTemplates[index].PONum;
        return (
            <div>
                <br/>
                <Row><Col sm={ 12 }>
                    <Translate value="purchase_template_no" />: {PONum}
                </Col></Row>
                <Row><Col sm={ 12 }>
                    <Translate value="vendor_name" />: {vendorName}
                </Col></Row>
                <Row><Col sm={ 12 }>
                    <Translate value="update_time" />: {updateTime}
                </Col></Row>
            </div>
        )
    }

    render() {
        const { handleSubmit, closeC, submitting, pristine, purchaseTemplateValue } = this.props;
        return (
            <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
                <Row>
                    {this.renderPurchaseTemplates()}
                </Row>
                {purchaseTemplateValue && this.renderTemplateDetail(purchaseTemplateValue.value) }
                <br/>
                <br/>
                <Row>
                    <button action="submit" className="btn btn-primary col-sm-11 buttonStyle" disabled={ submitting } ><Translate value="msg_select_a_purchase_template" /></button>
                </Row>
                <br/>
                <Row>
                    <button className="btn btn-danger col-sm-11 buttonStyle" onClick={(event) => { event.preventDefault(); closeC(); } } ><Translate value="cancel" /></button>
                </Row>
            </form>
        )
    }
}

export default PurchaseScheduleModal



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchaseScheduleModal.jsx